import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "../../lib/cx.js";

export type BadgeTone = "neutral" | "accent" | "success" | "warning" | "danger" | "outline" | "solid";

const TONES: Record<BadgeTone, string> = {
  neutral: "bg-surface-3 text-muted",
  accent: "bg-accent-soft text-accent-soft-fg",
  success: "bg-success-soft text-success-soft-fg",
  warning: "bg-warning-soft text-warning-soft-fg",
  danger: "bg-danger-soft text-danger-soft-fg",
  outline: "border border-border-strong text-muted",
  solid: "bg-fg text-bg",
};

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  icon?: ReactNode;
  size?: "sm" | "md";
}

export function Badge({ tone = "neutral", icon, size = "sm", className, children, ...rest }: BadgeProps) {
  return (
    <span
      className={cx(
        "inline-flex max-w-full items-center gap-1 rounded-md font-medium whitespace-nowrap [&>svg]:size-3.5 [&>svg]:shrink-0",
        size === "sm" ? "h-5 px-1.5 text-[11.5px]" : "h-6 px-2 text-xs",
        TONES[tone],
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
    </span>
  );
}
